<script lang="ts">
	import type {Conversation} from './types';
	import Locale from './Locale.svelte';
	import {showableLocales} from './services';

	export let conversation: Conversation;
</script>

{#if $showableLocales.length > 1}
	<small>
		<Locale locale={conversation.client.locale} />
	</small>
{/if}
